module.exports = __webpack_public_path__ + "img/icons8-mapa-start-24.d9a42888.svg";